import React from 'react';
import useGlobalStyles from '../../../useGlobalStyles';
import useFollowersFollowingCountStyles from './useFollowersFollowingCountStyles';
import { User } from '../../../../types';

/**
 * Props for the FollowersFollowingCount component.
 */
interface FollowersFollowingCountProps {
  followers: User[];
  following: User[];
  viewUser: User;
  currentUser: User | null;
  handleFollowersFollowingClick: (type: 'followers' | 'following') => void;
}

/**
 * FollowersFollowingCount component that renders the user's followers and following count.
 * @param followers - the number of followers the user has.
 * @param following - the number of users the user is following.
 * @returns - the FollowersFollowingCount component.
 */
const FollowersFollowingCount: React.FC<FollowersFollowingCountProps> = ({
  followers,
  following,
  viewUser,
  currentUser,
  handleFollowersFollowingClick,
}) => {
  const { classes } = useFollowersFollowingCountStyles();
  const { classes: globalClasses } = useGlobalStyles();

  return viewUser.username === currentUser?.username ? (
    <div className={`${globalClasses.container} ${classes.followerFollowingCount}`}>
      <div
        className={`${classes.followerFollowingCountEntry} ${classes.clickable}`}
        id='Followers'
        onClick={() => handleFollowersFollowingClick('followers')}>
        <p
          className={`${globalClasses.h6} ${classes.followerFollowingText} ${classes.clickableText}`}>
          Followers
        </p>
        <p className={globalClasses.p}>{followers.length}</p>
      </div>
      <div
        className={`${classes.followerFollowingCountEntry} ${classes.clickable}`}
        id='Following'
        onClick={() => handleFollowersFollowingClick('following')}>
        <p
          className={`${globalClasses.h6} ${classes.followerFollowingText} ${classes.clickableText}`}>
          Following
        </p>
        <p className={globalClasses.p}>{following.length}</p>
      </div>
    </div>
  ) : (
    <div className={`${globalClasses.container} ${classes.followerFollowingCount}`}>
      <div className={classes.followerFollowingCountEntry} id='Followers'>
        <p className={`${globalClasses.h6} ${classes.followerFollowingText}`}>Followers</p>
        <p className={globalClasses.p}>{followers.length}</p>
      </div>
      <div className={classes.followerFollowingCountEntry} id='Following'>
        <p className={`${globalClasses.h6} ${classes.followerFollowingText}`}>Following</p>
        <p className={globalClasses.p}>{following.length}</p>
      </div>
    </div>
  );
};

export default FollowersFollowingCount;
